<template>
    <div id="page-list-page">
        <h3 class="title">{{ $t("message.metaLeadPages") }}</h3>
        <div class="toolbar">
            <div></div>
            <div>
                <SupsisButton ghost primary @click="syncPages" :disabled="syncing">
                    <i class="material-icons" :class="{ spinning: syncing }">sync</i>
                    {{ $t("message.syncPages") }}
                </SupsisButton>
            </div>
        </div>
        <div class="table-wrapper">
            <SupsisTable
                :columns="getCols()"
                :rows="pages"
                empty-data-bordered
                :options="{
                    rowStyleOption,
                    fixedHeader: true,
                    id: 'pages-table',
                    borderX: true,
                    borderY: true,
                }"
            />
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import { mapState } from "vuex";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import { first, filter, timeout } from "rxjs/operators";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import SupsisTable from "../../../../components/SupsisTable.vue";

export default {
    name: "PageList",
    components: {
        SupsisButton,
        SupsisTable,
    },
    props: {
        channel: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            syncing: false,
            rowStyleOption: {
                stripe: true,
            },
        };
    },
    computed: {
        ...mapState({
            siteId: function (state) { return state.site.site._id; },
        }),
        pages() {
            return _.get(this.channel, "payload.tokenInfo.pages", []) || [];
        },
    },
    methods: {
        getCols() {
            return [
                {
                    key: "picture",
                    field: "picture",
                    title: "",
                    width: 60,
                    align: "center",
                    renderBodyCell: function (_ref, h) {
                        var row = _ref.row;
                        var picUrl = _.get(row, "picture.data.url");
                        if (picUrl) {
                            return h("a-avatar", {
                                props: { size: 32, src: picUrl, shape: "square" },
                                style: "border-radius: 6px",
                            });
                        }
                        return h("a-avatar", {
                            props: { size: 32, shape: "square" },
                            style: "background-color: #3899ff; border-radius: 6px",
                        }, (row.name || "?").substr(0, 1).toLocaleUpperCase());
                    },
                },
                {
                    key: "name",
                    field: "name",
                    title: this.$t("message.name"),
                    align: "left",
                },
                {
                    key: "id",
                    field: "id",
                    title: "Page ID",
                    align: "left",
                },
            ];
        },
        syncPages() {
            this.syncing = true;
            sendSocketMessage("meta sync-pages", {
                siteId: this.siteId,
                channelId: this.channel._id,
            });
            socketMessageStream
                .pipe(
                    first(function (x) { return x.cmd === "meta_sync_pages_response"; }),
                    timeout(60000)
                )
                .toPromise()
                .then(function (response) {
                    var data = response.data;
                    if (data.success) {
                        this.$message.success(this.$t("message.pagesSyncSuccess"));
                        this.$emit("pages-synced", data.pages);
                    } else {
                        this.$message.error(this.$t("message.pagesSyncFailed"));
                    }
                }.bind(this))
                .catch(function () {
                    this.$message.error(this.$t("message.pagesSyncFailed"));
                }.bind(this))
                .finally(function () {
                    this.syncing = false;
                }.bind(this));
        },
    },
};
</script>
<style lang="scss">
#pages-table {
    .ve-table-body-td {
        padding: 0 2px !important;
    }
}
</style>
<style scoped lang="scss">
#page-list-page {
    margin: 30px;

    .toolbar {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        gap: 5px;
    }

    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }

    .spinning {
        animation: spin 1s linear infinite;
    }
}
</style>
